import React from 'react'
import { Lazyload } from '~/components'
import * as st from '~/assets/styl/Dormitories.module.styl'
import img1 from '~/assets/img/piscina-vista-mar.webp'
import img2 from '~/assets/img/fachada-principal.webp'
import sunIcon from '~/assets/svg/facade-sun.svg'
import moonIcon from '~/assets/svg/facade-moon.svg'
import { useLanguage } from '~/hooks'

export default function Dormitories() {
  const { t } = useLanguage()
  return (
    <section className={`${st.core} ${st.empreendimento}`} id="Empreendimento">
      <div className={st.logo}>
        <span></span>
      </div>
      <Lazyload src={img1} className={st.img1} />
      <Lazyload src={img2} className={st.img2} />
      <div className={st.dorms}>
        <h2>{t('Dormitories.title')}</h2>
        <h3>{t('Dormitories.area')}</h3>
        <div className={st.facadeInfo}>
          <span className={st.facadeItem}>
            <img src={sunIcon} alt="" aria-hidden="true" />
            <span>{t('Dormitories.facadeDay')}</span>
          </span>
          <span className={`${st.facadeItem} ${st.facadeNight}`}>
            <img src={moonIcon} alt="" aria-hidden="true" />
            <span>{t('Dormitories.facadeNight')}</span>
          </span>
        </div>
      </div>
    </section>
  )
}
